import React, { Fragment } from 'react'

const PdfLayout = (props) => {
  return <div className="w-container">{props.children}</div>
}

export default PdfLayout
